import Vue from "vue";
import VueRouter from "vue-router";

import { Message } from "element-ui";

// 进度条
import NProgress from "nprogress";
import "nprogress/nprogress.css";

import store from "@/store";

import util from "@/libs/util.js";

// 路由数据
import routes from "./routes";

Vue.use(VueRouter);

// 初始化路由信息
store.commit("d2admin/router/init", routes);

// 导出路由 在 main.js 里使用
const router = new VueRouter({
  routes,
});

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location){
return originalReplace.call(this , location).catch(err=>err)
}

/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach((to, from, next) => {
  const route = store.state.d2admin.router.flatRouteList[to.name] || {}; // 当前路由信息
  const menuNameList = store.state.d2admin.router.menuNameList || []; // 菜单列表
  const token = util.cookies.get("token"); // token

  NProgress.start(); // 进度条开启
  store.commit("d2admin/search/set", false); // 关闭搜索面板

  if (route.meta?.pass) {
    next();
  } else if (token && token !== "undefined" && menuNameList.length) {
    if (route.meta?.hidden || route.meta?.auth) {
      next();
    } else {
      if (!from.name) {
        next({
          name: menuNameList[0] || "/",
        });
      } else {
        next(false);
      }
      Message({
        type: "error",
        message: "你没有权限访问该页面！",
      });
    }
  } else {
    if (from.name !== "login") {
      next({
        name: "login",
        query: {
          redirect: to.fullPath,
        },
      });
    } else {
      next(false);
    }
  }
  NProgress.done(); // 进度条关闭
});

router.afterEach((to) => {
  // 进度条
  NProgress.done();
  // 多页控制 打开新的页面
  store.dispatch("d2admin/page/open", to);
  // 更改标题
  util.title(to.meta.title);
});
export default router;
